import { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    if (this.props.fallback) return this.props.fallback;

    return (
      <div className="min-h-screen flex items-center justify-center bg-white px-6">
        <div className="max-w-md text-center">
          <h1 className="text-2xl font-bold text-neutral-900 mb-3">
            Algo salió mal
          </h1>
          <p className="text-neutral-600 mb-6 leading-relaxed">
            Tuvimos un problema cargando esta página. Reintentá en unos segundos.
            Si el problema persiste, escribinos por WhatsApp.
          </p>
          <button
            onClick={this.handleReload}
            className="px-6 py-3 bg-[#C5075D] text-white rounded-lg font-semibold hover:bg-[#A00550] transition-colors"
          >
            Reintentar
          </button>
        </div>
      </div>
    );
  }
}
